import { Zap } from "lucide-react";

export default function AuthShell({ children }) {
  return (
    <div className="relative z-10 min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-[#222634] bg-[#0A0C10]">
        <div className="flex items-center gap-2 text-[#00E676] font-bold text-xl">
          <Zap className="w-6 h-6" /> FullSniper
        </div>
        <div>
          <h1 className="text-5xl font-bold tracking-tight text-slate-100 leading-tight">
            full.fun coinlerini<br /><span className="text-[#00E676]">ilk sen gör,</span><br />tek tıkla al.
          </h1>
          <p className="mt-6 text-slate-400 max-w-md">Robinhood Chain üzerinde full.fun için terminal. Yeni basılan coinleri yakalayan sniper bot, hızlı alım-satım, TP/SL.</p>
        </div>
        <p className="font-mono text-xs text-slate-600">chainId 4663 · router 0xb67A…C43</p>
      </div>
      <div className="flex items-center justify-center p-4" data-testid="auth-container">{children}</div>
    </div>
  );
}
